import { render, staticRenderFns } from "./ZonaItem.vue?vue&type=template&id=5592a62e&scoped=true"
import script from "./ZonaItem.vue?vue&type=script&lang=js"
export * from "./ZonaItem.vue?vue&type=script&lang=js"
import style0 from "./ZonaItem.vue?vue&type=style&index=0&id=5592a62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5592a62e",
  null
  
)

export default component.exports